module.exports = __webpack_public_path__ + "img/nordhms-menu-logo.69614e28.svg";